import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { action, computed, observable, runInAction } from 'mobx';
import { filter } from '@atlaskit/adf-utils/traverse';
import { FormQuestionType, FormVisibility } from '../models/Form';
import { getFormAnalyticsAttributes } from '../utils';
import { QuestionStore, toChoiceQuestionAnswer } from './QuestionStore';
export var FormStore = (_class = /*#__PURE__*/function () {
  /**
   * Creates a new form store.
   *
   * @param intl The `intl` instance to pass to the `QuestionStore`s
   * @param createAnalyticsEvent The function to create an analytics event so it can be fired
   * @param loadFieldDataFn The function to generate the function to load the field data
   * @param loadChoicesFn The function to generate the function to load the form choices
   * @param loadChoicesAsyncFn The function to generate the function to load form choices async
   * @param searchUsers The function to search for users
   * @param searchUsersWithFieldConfig The function to search for users
   * @param form The form to populate the store with
   * @param populateDefaultValueOnEmptySearch For fields that support it (e.g. CMDB), whether to populate the field with a default value retrieved on an empty search query.
   * @param issueKey The key of the current issue, if known
   * @param jiraFieldMap The map of Jira fields (only used in the Form Builder)
   * @param onFieldChange optional callback function that is passed down to the QuestionStore on the portal create screen and is run when a question's answer changes
   * @param onFieldDirty optional callback function that is passed down to the QuestionStore on the portal create screen
   * and is run when a form is considered dirty. It has different behaviour to onFieldChange.
   */
  function FormStore(intl, createAnalyticsEvent, loadFieldDataFn, loadChoicesFn, loadChoicesAsyncFn, searchUsers, searchUsersWithFieldConfig, _form, populateDefaultValueOnEmptySearch, issueKey, jiraFieldMap, onFieldChange, onFieldDirty) {
    var _this = this,
      _form$publish,
      _form$publish2;
    _classCallCheck(this, FormStore);
    this.formId = void 0;
    this.issueKey = void 0;
    _initializerDefineProperty(this, "savingAnswers", _descriptor, this);
    _initializerDefineProperty(this, "submittingForm", _descriptor2, this);
    this.templateFormId = void 0;
    this.templateFormUuid = void 0;
    this.formName = void 0;
    this.language = void 0;
    _initializerDefineProperty(this, "updated", _descriptor3, this);
    _initializerDefineProperty(this, "status", _descriptor4, this);
    this.submitLock = void 0;
    this.submitPdf = void 0;
    _initializerDefineProperty(this, "questions", _descriptor5, this);
    this.layout = void 0;
    _initializerDefineProperty(this, "internal", _descriptor6, this);
    this.conditions = void 0;
    this.sections = void 0;
    _initializerDefineProperty(this, "invalid", _descriptor7, this);
    this.createOpen = void 0;
    this.validateOnCreate = void 0;
    this.portalCanSubmit = void 0;
    this.analyticsAttributes = void 0;
    this.prevVisibleSections = void 0;
    this.primaryLocale = void 0;
    this.translatedLocale = void 0;
    this.loadFieldData = void 0;
    this.loadChoices = void 0;
    this.loadChoicesAsync = void 0;
    this.searchUsers = void 0;
    this.searchUsersWithFieldConfig = void 0;
    _initializerDefineProperty(this, "attachQuestionsToSections", _descriptor8, this);
    this.getQuestionIdsFromSectionContent = function (sectionContent) {
      return filter(sectionContent, function (node) {
        if (!node.attrs || !node.attrs.parameters || !node.attrs.parameters.id) {
          return false;
        }
        return node.attrs.extensionKey === 'question';
      }).map(function (node) {
        return node.attrs.parameters.id.toString();
      });
    };
    _initializerDefineProperty(this, "update", _descriptor9, this);
    this._update = function (constructing, form) {
      var refreshChoices = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      _this.updated = form.updated;
      _this.status = form.state.status;
      _this.internal = form.state.visibility === FormVisibility.Internal;
      if (!constructing) {
        _this.invalid = false;
        _this.questions.forEach(function (question) {
          var questionKey = question.id.toString();
          var formQuestion = _objectSpread(_objectSpread({}, form.design.questions[questionKey]), {}, {
            choices: question.choices // Retain the current choices.
          });
          question.update(formQuestion, form.state.answers[questionKey]);
        });
        if (!refreshChoices) {
          return _this.loadFieldData().then(function () {
            return _this.afterUpdate();
          });
        }
      }
      return Promise.all([_this.loadFieldData(), _this.loadChoices()]).then(function () {
        return _this.afterUpdate();
      });
    };
    this.validate = function () {
      var visibleQuestions = _this.questions.filter(function (question) {
        return !_this.hiddenQuestions.includes(question.id.toString());
      });

      // Validate each question
      var allQuestionsValid = true;
      visibleQuestions.forEach(function (questionStore) {
        // activate validations on question
        questionStore.validate();
        if (!!questionStore.validationErrors) {
          allQuestionsValid = false;
        }
      });
      runInAction(function () {
        _this.invalid = !allQuestionsValid;
      });
    };
    _initializerDefineProperty(this, "hideValidations", _descriptor0, this);
    _initializerDefineProperty(this, "discardModifiedAnswers", _descriptor1, this);
    _initializerDefineProperty(this, "onFieldChange", _descriptor10, this);
    this.formId = _form.id;
    this.issueKey = issueKey;
    var formSettings = _form.design.settings;
    this.templateFormId = formSettings.templateId;
    this.templateFormUuid = formSettings.templateFormUuid;
    this.formName = formSettings.name;
    this.language = formSettings.language;
    this.submitLock = formSettings.submit.lock;
    this.submitPdf = formSettings.submit.pdf;
    this.createOpen = ((_form$publish = _form.publish) === null || _form$publish === void 0 ? void 0 : _form$publish.portal) !== undefined && !_form.publish.portal.submitOnCreate;
    this.validateOnCreate = !this.createOpen || ((_form$publish2 = _form.publish) === null || _form$publish2 === void 0 ? void 0 : _form$publish2.portal) !== undefined && _form.publish.portal.validateOnCreate;
    this.portalCanSubmit = !formSettings.portal || formSettings.portal.canSubmit;
    this.conditions = _form.design.conditions;
    this.layout = _form.design.layout;
    this.sections = _objectSpread({}, _form.design.sections);
    this.attachQuestionsToSections();
    this.analyticsAttributes = _objectSpread(_objectSpread({}, getFormAnalyticsAttributes(_form)), {}, {
      formId: this.formId,
      templateFormId: this.templateFormId
    });
    this.primaryLocale = formSettings.primaryLocale;
    this.translatedLocale = formSettings.translatedLocale;
    if (_form.design.questions) {
      this.questions = Object.keys(_form.design.questions).map(function (questionKey) {
        var formQuestion = _form.design.questions[questionKey];
        return new QuestionStore(intl, questionKey, formQuestion, function (query) {
          return loadChoicesAsyncFn(_this)(parseInt(questionKey, 10), query);
        }, function (fieldMeta, value) {
          _this.onFieldChange(fieldMeta.jiraField);
          onFieldChange === null || onFieldChange === void 0 || onFieldChange(fieldMeta, value);
        }, populateDefaultValueOnEmptySearch, _form.state.answers[questionKey], onFieldDirty);
      });
    } else {
      this.questions = [];
    }
    this.loadFieldData = loadFieldDataFn(this);
    this.loadChoices = loadChoicesFn(this);
    this.loadChoicesAsync = loadChoicesAsyncFn(this);
    this.searchUsers = searchUsers;
    this.searchUsersWithFieldConfig = searchUsersWithFieldConfig;
    this._update(true, _form);
  }
  return _createClass(FormStore, [{
    key: "formIsBlank",
    get: function get() {
      if (!this.layout) {
        return true;
      }
      return this.layout.every(function (subLayout) {
        return subLayout.content.length === 0;
      });
    }
  }, {
    key: "answersModified",
    get: function get() {
      var _iterator = _createForOfIteratorHelper(this.questions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var questionStore = _step.value;
          if (questionStore.answerModified) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "satisfiedConditions",
    get: function get() {
      var _this2 = this;
      if (!this.conditions) {
        return [];
      }
      var satisfiedConditions = [];
      Object.keys(this.conditions).forEach(function (conditionKey) {
        // @ts-ignore
        var condition = _this2.conditions[conditionKey];
        if (_this2.conditionIsSatisfied(condition)) {
          satisfiedConditions.push(conditionKey);
        }
      });
      return satisfiedConditions;
    }
  }, {
    key: "conditionIsSatisfied",
    value: function conditionIsSatisfied(condition) {
      var _this3 = this;
      // Currently this code only supports conditions with 'choice - one of' inputs
      if (condition.i.co) {
        var _loop = function _loop(conditionQuestionId) {
            var trackedQuestion = _this3.questions.find(function (question) {
              return "".concat(question.id) === conditionQuestionId;
            });
            var currentAnswer = toChoiceQuestionAnswer(trackedQuestion === null || trackedQuestion === void 0 ? void 0 : trackedQuestion.currentAnswer);
            if (!(currentAnswer !== null && currentAnswer !== void 0 && currentAnswer.choices)) {
              return {
                v: false
              };
            }
            var conditionInput = condition.i.co.cIds[conditionQuestionId];
            return {
              v: currentAnswer.choices.some(function (choice) {
                return conditionInput.includes(choice) || conditionInput.includes(choice.split(':')[0]);
              })
            };
          },
          _ret;
        // Currently this code only supports one input per condition, because it returns from the first iteration of this loop
        for (var conditionQuestionId in condition.i.co.cIds) {
          _ret = _loop(conditionQuestionId);
          if (_ret) return _ret.v;
        }
      }
      return false;
    }
  }, {
    key: "visibleSections",
    get: function get() {
      var _this4 = this;
      if (!this.sections) {
        return ['0'];
      }
      var satisfiedConditions = this.satisfiedConditions;
      var visibleSections = ['0'];
      Object.keys(this.sections).forEach(function (sectionKey) {
        var section = _this4.sections[sectionKey];
        if (!section.conditions) {
          visibleSections.push(sectionKey);
        }
        if (section.conditions && section.conditions.every(function (condition) {
          return satisfiedConditions.includes(condition);
        })) {
          visibleSections.push(sectionKey);
        }
      });
      return visibleSections;
    }
  }, {
    key: "hiddenQuestions",
    get: function get() {
      var _this5 = this;
      if (!this.sections) {
        return this.questions.map(function (question) {
          return question.id.toString();
        });
      }
      var hiddenSections = [];
      Object.keys(this.sections).forEach(function (sectionKey) {
        if (!_this5.visibleSections.includes(sectionKey)) {
          hiddenSections.push(_this5.sections[sectionKey]);
        }
      });
      return this.questions.filter(function (question) {
        return hiddenSections.some(function (hiddenSection) {
          return hiddenSection.questions && hiddenSection.questions.includes(question.id.toString());
        });
      }).map(function (question) {
        return question.id.toString();
      });
    }
  }, {
    key: "visibleQuestions",
    get: function get() {
      var _this6 = this;
      return this.questions.filter(function (question) {
        return !_this6.hiddenQuestions.includes(question.id.toString());
      });
    }
  }, {
    key: "isUploadingMedia",
    get: function get() {
      var _iterator2 = _createForOfIteratorHelper(this.questions),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var questionStore = _step2.value;
          if (questionStore.isUploadingMedia) {
            return true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }, {
    key: "hasAttachmentField",
    get: function get() {
      var _iterator3 = _createForOfIteratorHelper(this.questions),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var questionStore = _step3.value;
          if (questionStore.formQuestion.type === FormQuestionType.Attachment) {
            return true;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return false;
    }
  }, {
    key: "numberOfAttachment",
    get: function get() {
      var size = 0;
      var _iterator4 = _createForOfIteratorHelper(this.questions),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var questionStore = _step4.value;
          if (questionStore.formQuestion.type === FormQuestionType.Attachment) {
            var attachments = questionStore.currentAnswer;
            size += attachments.length;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return size;
    }
  }, {
    key: "attachmentIds",
    get: function get() {
      var attachmentIds = new Set();
      var _iterator5 = _createForOfIteratorHelper(this.questions),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var questionStore = _step5.value;
          if (questionStore.formQuestion.type === FormQuestionType.Attachment) {
            var attachments = questionStore.answer ? questionStore.answer : [];
            attachments.forEach(function (attachment) {
              return attachmentIds.add(attachment.id);
            });
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return attachmentIds;
    }
  }, {
    key: "afterUpdate",
    value: function afterUpdate() {
      this.prevVisibleSections = this.visibleSections;
      this.visibleQuestions.forEach(function (question) {
        return question.doPopulateDefaultValueOnEmptySearch();
      });
    }
  }, {
    key: "getNewlyVisibleQuestions",
    value: function getNewlyVisibleQuestions() {
      var _this7 = this;
      if (!this.prevVisibleSections) {
        // Don't calculate any questions as becoming newly visible until the form is loaded fully and this field is set.
        return [];
      }
      var newlyVisibleSections = this.visibleSections.filter(function (sectionId) {
        var _this7$prevVisibleSec;
        return !((_this7$prevVisibleSec = _this7.prevVisibleSections) !== null && _this7$prevVisibleSec !== void 0 && _this7$prevVisibleSec.includes(sectionId));
      });
      var newlyVisibleQuestions = newlyVisibleSections.reduce(function (accumulatedQuestions, sectionId) {
        var _this7$sections;
        var section = (_this7$sections = _this7.sections) === null || _this7$sections === void 0 ? void 0 : _this7$sections[sectionId];
        if (!section) {
          return accumulatedQuestions;
        }
        return [].concat(_toConsumableArray(accumulatedQuestions), _toConsumableArray(_this7.questions.filter(function (question) {
          var _section$questions;
          return (_section$questions = section.questions) === null || _section$questions === void 0 ? void 0 : _section$questions.includes(question.id.toString());
        })));
      }, []);
      this.prevVisibleSections = this.visibleSections;
      return newlyVisibleQuestions;
    }
  }]);
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "savingAnswers", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "submittingForm", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "updated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "questions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "internal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "invalid", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "formIsBlank", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formIsBlank"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answersModified", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "answersModified"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "satisfiedConditions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "satisfiedConditions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleSections", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visibleSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hiddenQuestions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hiddenQuestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleQuestions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "visibleQuestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUploadingMedia", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUploadingMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasAttachmentField", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAttachmentField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberOfAttachment", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberOfAttachment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "attachmentIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "attachmentIds"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "attachQuestionsToSections", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      if (!_this8.layout || !_this8.layout[0]) {
        return;
      }
      var sectionsAdf = _this8.layout.map(function (sectionLayout, index) {
        return {
          id: index,
          questions: sectionLayout.content ? _this8.getQuestionIdsFromSectionContent(sectionLayout) : []
        };
      });
      sectionsAdf.forEach(function (section) {
        var sections = _this8.sections;
        if (sections && sections[section.id]) {
          sections[section.id].questions = section.questions;
        }
      });
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "update", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function (form) {
      var refreshChoices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this9._update(false, form, refreshChoices);
    };
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "hideValidations", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this0 = this;
    return function () {
      _this0.invalid = false;
      _this0.questions.forEach(function (question) {
        return question.hideValidation();
      });
    };
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "discardModifiedAnswers", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this1 = this;
    return function () {
      _this1.questions.forEach(function (question) {
        return question.discardModifiedAnswer();
      });
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "onFieldChange", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function (jiraField) {
      var dependentVisibleQuestions = jiraField ? _this10.visibleQuestions.filter(function (question) {
        var _question$issueFieldD;
        return (_question$issueFieldD = question.issueFieldData) === null || _question$issueFieldD === void 0 || (_question$issueFieldD = _question$issueFieldD.dependsOn) === null || _question$issueFieldD === void 0 ? void 0 : _question$issueFieldD.includes(jiraField);
      }) : [];
      var newlyVisibleNonDependentQuestions = _this10.getNewlyVisibleQuestions().filter(function (newlyVisibleQuestion) {
        return !dependentVisibleQuestions.some(function (dependentQuestion) {
          return dependentQuestion.id === newlyVisibleQuestion.id;
        });
      });
      dependentVisibleQuestions.forEach(function (question) {
        question.onDependentFieldChanged();
        question.doPopulateDefaultValueOnEmptySearch();
      });
      newlyVisibleNonDependentQuestions.forEach(function (question) {
        return question.doPopulateDefaultValueOnEmptySearch();
      });
    };
  }
})), _class);